import React, { useState } from 'react'
import Dashboard from './pages/Dashboard.js'
import Upload from './pages/Upload.js'
import Review from './pages/Review.js'
import Settings from './pages/Settings.js'
import Usage from './pages/Usage.js'
import About from './pages/About.js'
import Changelog from './pages/Changelog.js'
import type { ReviewPayload } from '@shared/types.js'

export type ViewState =
    | { name: 'dashboard' }
    | { name: 'upload' }
    | { name: 'review'; payload: ReviewPayload }
    | { name: 'settings' }
    | { name: 'usage' }
    | { name: 'about' }
    | { name: 'changelog' }

function App() {
    const [view, setView] = useState<ViewState>({ name: 'dashboard' })

    // Simple navigation functions
    const goDashboard = () => setView({ name: 'dashboard' })
    const goUpload = () => setView({ name: 'upload' })
    const goReview = (payload: ReviewPayload) => setView({ name: 'review', payload })
    const goSettings = () => setView({ name: 'settings' })
    const goUsage = () => setView({ name: 'usage' })
    const goAbout = () => setView({ name: 'about' })
    const goChangelog = () => setView({ name: 'changelog' })

    return (
        <div className="animate-fade-in">
            {/* Navigation Bar */}
            <nav className="navbar container">
                <div className="flex items-center gap-sm">
                    {/* Simple logo using text and gradient */}
                    <div className="text-gradient" style={{ fontSize: '1.5rem', fontWeight: 700, letterSpacing: '-0.05em' }}>
                        OpenCast
                    </div>
                </div>
                <div className="nav-links">
                    <button
                        className={`btn ${view.name === 'dashboard' ? 'btn-primary' : 'btn-secondary'}`}
                        style={{ border: 'none', background: view.name === 'dashboard' ? '' : 'transparent' }}
                        onClick={goDashboard}
                    >
                        Dashboard
                    </button>
                    <button
                        className={`btn ${view.name === 'settings' ? 'btn-primary' : 'btn-secondary'}`}
                        style={{ border: 'none', background: view.name === 'settings' ? '' : 'transparent' }}
                        onClick={goSettings}
                    >
                        Settings
                    </button>
                    <button
                        className={`btn ${view.name === 'usage' ? 'btn-primary' : 'btn-secondary'}`}
                        style={{ border: 'none', background: view.name === 'usage' ? '' : 'transparent' }}
                        onClick={goUsage}
                    >
                        API Usage
                    </button>
                    <button
                        className={`btn ${view.name === 'about' ? 'btn-primary' : 'btn-secondary'}`}
                        style={{ border: 'none', background: view.name === 'about' ? '' : 'transparent' }}
                        onClick={goAbout}
                    >
                        About
                    </button>
                    <button
                        className={`btn ${view.name === 'changelog' ? 'btn-primary' : 'btn-secondary'}`}
                        style={{ border: 'none', background: view.name === 'changelog' ? '' : 'transparent' }}
                        onClick={goChangelog}
                    >
                        Changelog
                    </button>
                    <button
                        className="btn btn-primary"
                        onClick={goUpload}
                    >
                        + New Episode
                    </button>
                </div>
            </nav>

            {/* Main Content Area */}
            <main className="container">
                {view.name === 'dashboard' && <Dashboard onNew={goUpload} />}
                {view.name === 'upload' && <Upload onCancel={goDashboard} onReview={goReview} />}
                {view.name === 'review' && <Review payload={view.payload} onCancel={goDashboard} onSuccess={goDashboard} />}
                {view.name === 'settings' && <Settings />}
                {view.name === 'usage' && <Usage />}
                {view.name === 'about' && <About />}
                {view.name === 'changelog' && <Changelog />}
            </main>
        </div>
    )
}

export default App
